import React, { useEffect, useState } from "react";

function Message(props) {
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  
  return (
    <div className="messageBlock">
     
      {props.text.map((item,i)=>{
          if(item.type==="receive"){

              return <h6 style={{textAlign:"left"}}>{item.text}</h6>
          }
          if(item.type==="send"){

            return <h6 style={{textAlign:"right"}}>{item.text}</h6>
        }
 })}

      
      
      
    </div>
  );
}

export default Message;
